import { convertToRaw } from 'draft-js';
export const pegarConteudo = (state = {}, chave = "padrao") => {
  const { [chave]: editor, padrao: editorPadrao } = state.editor.editores;
  return !!editor
    ? JSON.stringify(convertToRaw(editor.getCurrentContent()))
    : JSON.stringify(convertToRaw(editorPadrao.getCurrentContent()));
};


// WEBPACK FOOTER //
// ./src/componentes/editor/seletores.js